const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  icon: {
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing.unit,
    borderRadius: '100px',
    borderColor: theme.palette.border.lighter,
    borderWidth: '1px',
    borderStyle: 'solid',
    marginRight: theme.spacing.unit * 2.5,
    width: 40,
    height: 40,
  },
  cardNote: {},
});

export default styles;
